'use client';

import React, { useState } from 'react';
import {
    TypeButtonWithoutUnresolvableLinksResponse,
    TypeFormHousingWithoutUnresolvableLinksResponse,
} from '../../_generated';
import { TGeneralComponent } from '../../types/types';
import classNames from 'classnames';
import Button from '@/components/Button/Button';
import { Modal } from '@/components/Modal/Modal';
import FormHousing from './FormHousing/FormHousing';
import { API_ASSET_ROUTE } from '@/config/constants';
import { handleLinkClick, isIOS } from '@/utils/handleLinkClick';

export const ButtonWrapper: React.FC<{
    component: TGeneralComponent;
}> = ({ component }) => {
    const { fields } = component as TypeButtonWithoutUnresolvableLinksResponse;

    const pardotForm =
        fields?.modalFormReference as TypeFormHousingWithoutUnresolvableLinksResponse;

    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleModalOpen = () => {
        setIsModalOpen(true);
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
    };

    const assetUrl = fields.asset?.fields?.file?.url
        ? `${process.env.NEXT_PUBLIC_SITE_URL}${API_ASSET_ROUTE}${fields.asset?.fields?.file?.fileName}`
        : '';

    return (
        <>
            {pardotForm && (
                <Modal
                    isOpen={isModalOpen}
                    handleClose={handleModalClose}
                    withPadding={true}
                    classes={{
                        root: 'sm:tw-max-w-[500px] md:tw-max-w-[500px] lg:tw-max-w-[500px] lg:tw-w-[90%] tw-bg-modalGrayBg tw-min-h-full sm:tw-min-h-0 tw-bg-modalGrayBg sm:tw-bg-white sm:tw-max-w-[500px] sm:tw-min-h-0',
                        container: 'tw-bg-modalGrayBg tw-bg-white lg:tw-pb-[20px]',
                    }}
                >
                    <FormHousing
                        formData={pardotForm}
                        formId={pardotForm.sys.id}
                        closeModal={handleModalClose}
                    />
                </Modal>
            )}
            <div
                className={classNames('tw-flex', {
                    'tw-justify-start': fields?.buttonPosition === 'Left',
                    'tw-justify-center': fields?.buttonPosition === 'Center',
                    'tw-justify-end': fields?.buttonPosition === 'Right',
                })}
            >
                <Button
                    path={fields.link ?? assetUrl}
                    target={fields.target}
                    label={fields?.title}
                    backgroundColor={fields?.color}
                    onClickCallback={fields?.target === '_modal' ? handleModalOpen : undefined}
                    onLinkClickCallback={
                        isIOS && fields.asset?.fields?.file?.fileName
                            ? (e: React.MouseEvent<HTMLAnchorElement>) =>
                                  handleLinkClick(e, fields.asset?.fields?.file?.url)
                            : undefined
                    }
                />
            </div>
        </>
    );
};
